/* @flow */

import React from 'react'
import NavigationButtons from 'atpjs/components/navigation_buttons'
import { TextInput, EmailInput, TelInput } from 'atpjs/components/form/input'
import DateInput from 'atpjs/components/form/date'
import Checkbox from 'atpjs/components/form/checkbox'
import Radio from 'atpjs/components/form/radio'
import { createOptions } from 'atpjs/components/form/values'
import {
  nonEmptyString,
  email,
  numeric,
  maxLength,
  minLength,
  validDate,
  belowDate,
  equals
} from 'atpjs/validation/validators'
import { and, or } from 'atpjs/validation/functions'
import i18n from 'atpjs/helpers/i18n'
import Step from 'tve/views/step'
import Application from 'tve/components/application'
import Navigation from 'tve/components/navigation'
import { phone } from 'tve/helpers/custom_phone_validator'

import type { PrefixType } from 'atpjs/helpers/i18n'

const t = i18n.prefix(['userForm'])

class UserForm extends Step {
  sendData = true

  constructor(props) {
    super(props)
    this.genderValues = createOptions(['options', 'gender'], ['male', 'female'])

    this.termsAndConditionsValues = [
      {
        value: 1,
        label: i18n.component(
          ['attributes', 'labels', 'termsAndConditions'],
          {},
          {
            components: {
              a: {
                component: 'a',
                props: { onClick: this.openTermsAndConditions, rel: 'noreferrer', target: '_blank' }
              }
            }
          }
        )
      }
    ]
  }

  validations(_trans: PrefixType) {
    return {
      ...(this.isCorporate() ? { company: nonEmptyString() } : {}),
      gender: nonEmptyString(),
      firstName: nonEmptyString(),
      lastName: nonEmptyString(),
      email: email(),
      phone: phone(),
      street: nonEmptyString(),
      zip: and(numeric(), or(maxLength(4), minLength(4))),
      city: nonEmptyString(),
      birthDate: and(validDate(), belowDate(new Date())),
      termsAndConditions: equals(true)
    }
  }

  openTermsAndConditions = (event) => {
    event.stopPropagation()
  }

  isCorporate() {
    return this.getData(['customerType']) === 'corporate'
  }

  render() {
    const inputSetProps = this.inputSetProps()

    return (
      <Application
        title={t(['title'])}
        name={i18n.trans(['tve', 'title'])}
        navigation={<Navigation data={this.getHandler()} next={this.previousHandler} />}>
        <form onSubmit={this.onSubmit}>
          {this.getData(['login']) && (
            <div className="atp-notification">
              <span>{t(['existingCustomer'])}</span>
            </div>
          )}
          {this.isCorporate() && (
            <div className="atp-grid atp-margin-top-no">
              <div className="atp-grid-1-1">
                <TextInput {...inputSetProps(['company'])} />
              </div>
            </div>
          )}
          <div className="atp-grid atp-margin-top-no">
            <div className="atp-grid-1-1">
              <Radio {...inputSetProps(['gender'])} values={this.genderValues} direction="horizontal" />
            </div>
          </div>
          <div className="atp-grid atp-margin-top-no">
            <div className="atp-grid-2-1 atp-grid-m-1-1 atp-offset-m-1-0">
              <TextInput {...inputSetProps(['firstName'])} maxLength="50" />
            </div>
            <div className="atp-grid-2-1 atp-grid-m-1-1 atp-offset-m-1-0">
              <TextInput {...inputSetProps(['lastName'])} maxLength="50" />
            </div>
          </div>
          <div className="atp-grid atp-margin-top-no">
            <div className="atp-grid-1-1">
              <EmailInput {...inputSetProps(['email'])} />
            </div>
          </div>
          <div className="atp-grid atp-margin-top-no">
            <div className="atp-grid-2-1 atp-grid-m-1-1 atp-offset-m-1-0">
              <TelInput {...inputSetProps(['phone'])} />
            </div>
          </div>
          <div className="atp-grid atp-margin-top-no">
            <div className="atp-grid-1-1">
              <TextInput {...inputSetProps(['street'])} />
            </div>
          </div>
          <div className="atp-grid atp-margin-top-no">
            <div className="atp-grid-4-1 atp-grid-m-1-1 atp-offset-m-1-0">
              <TelInput {...inputSetProps(['zip'])} maxLength="4" pattern="\d*" />
            </div>
            <div className="atp-grid-4-3 atp-grid-m-1-1 atp-offset-m-1-0">
              <TextInput {...inputSetProps(['city'])} />
            </div>
          </div>
          <div className="atp-grid atp-margin-top-no">
            <div className="atp-grid-2-1">
              <DateInput {...inputSetProps(['birthDate'])} />
            </div>
          </div>
          <div className="atp-grid atp-margin-top-no">
            <div className="atp-grid-1-1">
              <Checkbox
                {...inputSetProps(['termsAndConditions'], { label: null })}
                disabled={!!inputSetProps(['id']).value}
                values={this.termsAndConditionsValues}
              />
            </div>
          </div>
          <br />
          <NavigationButtons
            nextAction={this.nextHandler}
            previousAction={this.previousHandler}
            order={['previous', 'next']}
            nextLabel={i18n.trans(['buttons', 'bookNow'])}
            previousProps={{ className: 'atp-show-for-l-down' }}
          />
        </form>
      </Application>
    )
  }
}

export default UserForm
